export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n || 0);

export const pricingLabel = (t, type) => {
  const map = {
    per_person: "exp.perperson",
    per_boat: "exp.perboat",
    per_vehicle: "exp.pervehicle",
    per_group: "exp.pergroup",
    fixed: "exp.fixed",
  };
  return t(map[type] || "exp.perperson");
};

export const formatDate = (d, lang = "it") => {
  try {
    return new Date(d).toLocaleDateString(lang, { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return d;
  }
};

export const catName = (cat, lang) => {
  if (!cat) return "";
  return cat[`name_${lang}`] || cat.name_it || cat.slug;
};

// Commission display: internal fraction (0.18) <-> percent (18)
export const fracToPct = (v) => Math.round((Number(v) || 0) * 1000) / 10;
export const pctToFrac = (v) => (Number(v) || 0) / 100;
export const commissionLabel = (type, value) =>
  type === "percentage" ? `${fracToPct(value)}%` : eur(value);
